import React, { useState, useEffect } from 'react';
import CampoBuscarClub from '../UI/campos/CampoBuscarClub.js';
import ComboSelector from '../UI/campos/ComboSelector.js';
import CuadroDatos from '../UI/CuadroDatos.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import * as TipoRival from '../constantes/TipoRival.js';
import * as Categorias from '../constantes/Categorias.js';
import * as Data from '../data/DataHistoriales.js';
import * as Funciones from '../funciones/FuncionesHistoriales.js';
import styles from './SelectorRival.module.css';

const listaCategorias = [
  { id: null, descripcion: 'Todas' },
  { id: Categorias.MAYOR, descripcion: 'Mayor' },
];

const tiposInternacional = [
  { id: 'A', descripcion: 'Absoluto' },
  { id: null, descripcion: 'Todos' },
];

const SelectorRival = (props) => {
  const tipoHistorial = props.tipoHistorial;
  const competidor = props.competidor;
  const [tipoRival, setTipoRival] = useState(Funciones.TipoRivalInicial(tipoHistorial));
  const [modoTotales, setModoTotales] = useState(true);
  const [clubRival, setClubRival] = useState(null);
  const [categoriaClub, setCategoriaClub] = useState(listaCategorias[1]);
  const [equipoRival, setEquipoRival] = useState(null);
  const [categoriaEquipo, setCategoriaEquipo] = useState(listaCategorias[1]);
  const [paisSeleccion, setPaisSeleccion] = useState(null);
  const [categoriaSeleccion, setCategoriaSeleccion] = useState(listaCategorias[1]);
  const [tipoInternacional, setTipoInternacional] = useState(tiposInternacional[0]);
  const [listaRivales, setListaRivales] = useState([]);
  const [isCargandoRivales, setIsCargandoRivales] = useState(false);

  const idCompetidor = competidor?.id;
  const idTipoRival = tipoRival?.id;
  const mostrarTipoInternacional =
    tipoHistorial === TipoEquipo.SELECCION &&
    idTipoRival === TipoRival.SELECCION &&
    categoriaSeleccion?.id === Categorias.MAYOR;
  const prefijoHistorial = Data.GetPrefijo(tipoHistorial);

  useEffect(() => {
    if (!idCompetidor) {
      setListaRivales([]);
      return;
    }
    let tipoIntl = null;
    switch (idTipoRival) {
      case TipoRival.CLUB:
        // si busca historiales de un club no carga la lista
        if (tipoHistorial === TipoEquipo.CLUB) {
          setListaRivales([]);
          return;
        }
        break;
      case TipoRival.EQUIPO:
        break;
      case TipoRival.SELECCION:
        // si no hay seleccionada categoría no carga la lista
        if (!categoriaSeleccion?.id) {
          setListaRivales([]);
          return;
        }
        tipoIntl =
          tipoHistorial === TipoEquipo.SELECCION && mostrarTipoInternacional
            ? tipoInternacional
            : null;
        break;
      default:
    }
    setIsCargandoRivales(true);
    Data.GetRivales(tipoHistorial, idCompetidor, idTipoRival, categoriaSeleccion, tipoIntl).then(
      (lista) => {
        const rivales = (lista || []).map((rival) => ({
          id: rival.id,
          nombre:
            (idTipoRival === TipoRival.CLUB || idTipoRival === TipoRival.EQUIPO) &&
            rival.pais?.nombre
              ? `${rival.nombre} (${rival.pais.nombre})`
              : rival.nombre,
        }));
        setListaRivales(rivales);
        setIsCargandoRivales(false);
      }
    );
  }, [
    tipoHistorial,
    idCompetidor,
    idTipoRival,
    categoriaSeleccion,
    tipoInternacional,
    mostrarTipoInternacional,
  ]);

  useEffect(() => {
    setPaisSeleccion(null);
  }, [idTipoRival]);

  const categoriaActual =
    idTipoRival === TipoRival.CLUB
      ? categoriaClub
      : idTipoRival === TipoRival.EQUIPO
        ? categoriaEquipo
        : categoriaSeleccion;

  const onTipoRivalElegido = (tipoElegido) => {
    setTipoRival(tipoElegido);
    setModoTotales(true);
  };

  const onCategoriaElegida = (categoriaElegida) => {
    if (idTipoRival === TipoRival.CLUB) setCategoriaClub(categoriaElegida);
    else if (idTipoRival === TipoRival.EQUIPO) setCategoriaEquipo(categoriaElegida);
    else setCategoriaSeleccion(categoriaElegida);
  };

  const getLabelRival = () => {
    if (idTipoRival === TipoRival.SELECCION) return 'País Rival';
    return `${tipoRival?.descripcion} Rival`;
  };

  const onBuscar = () => {
    const rival = modoTotales
      ? null
      : idTipoRival === TipoRival.CLUB
        ? clubRival
        : idTipoRival === TipoRival.EQUIPO
          ? equipoRival
          : paisSeleccion;
    if (props.onBuscar) {
      props.onBuscar(
        Funciones.ArmarRival(
          idTipoRival,
          modoTotales,
          rival,
          categoriaActual,
          mostrarTipoInternacional ? tipoInternacional : null
        )
      );
    }
  };

  const buscarDeshabilitado =
    !modoTotales &&
    ((idTipoRival === TipoRival.CLUB && !clubRival) ||
      (idTipoRival === TipoRival.EQUIPO && !equipoRival) ||
      (idTipoRival === TipoRival.SELECCION && !paisSeleccion));

  let tituloRival = 'Rival';
  let campoRival = null;
  if (!modoTotales) {
    switch (idTipoRival) {
      case TipoRival.CLUB:
        tituloRival = 'Club Rival';
        if (tipoHistorial === TipoEquipo.CLUB) {
          campoRival = (
            <CampoBuscarClub
              prefiltro={prefijoHistorial}
              objetoFiltro={{ idCompetidor, categoria: categoriaClub }}
              nombre={TipoRival.CLUB}
              valor={clubRival}
              editar={true}
              width="100%"
              onClubElegido={(campo, c) => setClubRival(c || null)}
            />
          );
        } else if (tipoHistorial === TipoEquipo.SELECCION) {
          campoRival = (
            <ComboSelector
              lista={listaRivales}
              valorActual={clubRival}
              campoClave={'id'}
              campoDescripcion={'nombre'}
              isCargando={isCargandoRivales}
              onItemElegido={(p) => setClubRival(p || null)}
            />
          );
        }
        break;
      case TipoRival.EQUIPO:
        tituloRival = 'Equipo Rival';
        campoRival = (
          <ComboSelector
            lista={listaRivales}
            valorActual={equipoRival}
            campoClave={'id'}
            campoDescripcion={'nombre'}
            isCargando={isCargandoRivales}
            onItemElegido={(p) => setEquipoRival(p || null)}
          />
        );
        break;
      case TipoRival.SELECCION:
        tituloRival = 'País Rival';
        campoRival = (
          <ComboSelector
            lista={listaRivales}
            valorActual={paisSeleccion}
            campoClave={'id'}
            campoDescripcion={'nombre'}
            isCargando={isCargandoRivales}
            onItemElegido={(p) => setPaisSeleccion(p || null)}
          />
        );
        break;
      default:
        campoRival = null;
    }
  }

  return (
    <CuadroDatos titulo="Rival" isCargando={false} errores={false}>
      <div className={`${styles.contenedor}`}>
        <span className={`${styles.titulo}`}>Tipo Rival</span>
        <ComboSelector
          lista={Funciones.TiposRival}
          valorActual={tipoRival}
          campoClave={'id'}
          campoDescripcion={'descripcion'}
          isCargando={false}
          onItemElegido={onTipoRivalElegido}
        />

        <div className={`${styles.opciones}`}>
          <label className={`${styles.opcion}`}>
            <input type="radio" checked={modoTotales} onChange={() => setModoTotales(true)} />
            Totales
          </label>
          <label className={`${styles.opcion}`}>
            <input type="radio" checked={!modoTotales} onChange={() => setModoTotales(false)} />
            {getLabelRival()}
          </label>
        </div>

        {!modoTotales && campoRival && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>{tituloRival}</span>
            {campoRival}
          </React.Fragment>
        )}

        <span className={`${styles.titulo}`}>Categoría</span>
        <ComboSelector
          lista={listaCategorias}
          valorActual={categoriaActual}
          campoClave={'id'}
          campoDescripcion={'descripcion'}
          isCargando={false}
          onItemElegido={onCategoriaElegida}
        />

        {mostrarTipoInternacional && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>Tipo Internacional</span>
            <ComboSelector
              lista={tiposInternacional}
              valorActual={tipoInternacional}
              campoClave={'id'}
              campoDescripcion={'descripcion'}
              isCargando={false}
              onItemElegido={(t) => setTipoInternacional(t)}
            />
          </React.Fragment>
        )}

        <button
          className={`${styles.botonBuscar}`}
          disabled={buscarDeshabilitado}
          onClick={onBuscar}
        >
          Buscar
        </button>
      </div>
    </CuadroDatos>
  );
};

export default SelectorRival;
